"use strict";

var _reactTransformCatchErrors2 = require("react-transform-catch-errors");

var _interopRequireDefault = require("babel-runtime/helpers/interop-require-default")["default"];

var _reactTransformCatchErrors3 = _interopRequireDefault(_reactTransformCatchErrors2);

var _react = require("react");

var _redboxReact = require("redbox-react");

var _inherits = require("babel-runtime/helpers/inherits")["default"];

var _classCallCheck = require("babel-runtime/helpers/class-call-check")["default"];

exports.__esModule = true;

var _react2 = _interopRequireDefault(_react);

var _components = {
  _$AppSvgIcons: {
    displayName: "AppSvgIcons"
  }
};

var _reactComponentWrapper = _reactTransformCatchErrors3["default"]({
  filename: "/var/www/websites/blog.paymentwall.com/releases/20220825105928/src/components/AppSvgIcons/AppSvgIcons.js",
  components: _components,
  locals: [],
  imports: [_react, _redboxReact]
});

var _reactComponentWrapper2 = _reactTransformCatchErrors3["default"]({
  filename: "/var/www/websites/blog.paymentwall.com/releases/20220825105928/src/components/AppSvgIcons/AppSvgIcons.js",
  components: _components,
  locals: [],
  imports: [_react, _redboxReact]
});

function _wrapComponent(uniqueId) {
  return function (ReactClass) {
    return _reactComponentWrapper2(_reactComponentWrapper(ReactClass, uniqueId), uniqueId);
  };
}

var AppSvgIcons = (function (_Component) {
  _inherits(AppSvgIcons, _Component);

  function AppSvgIcons() {
    _classCallCheck(this, _AppSvgIcons);

    _Component.apply(this, arguments);
  }

  AppSvgIcons.prototype.render = function render() {
    return _react2["default"].createElement(
      "div",
      null,
      _react2["default"].createElement(
        "svg",
        { className: "is-hidden", xmlns: "http://www.w3.org/2000/svg" },
        _react2["default"].createElement(
          "symbol",
          { id: "icon-facebook" },
          _react2["default"].createElement("path", { d: "M7.828 4.04h2.71V0H7.353v.01c-3.857.14-4.65 2.33-4.72 4.63h-.006v2.02H0v3.96h2.627v10.62h3.96V10.62H9.83l.626-3.96h-3.87V5.44a1.3 1.3 0 0 1 1.242-1.4z", "shape-rendering": "geometricPrecision" })
        ),
        _react2["default"].createElement(
          "symbol",
          { id: "icon-googleplus" },
          _react2["default"].createElement("path", { d: "M6.602.56a9.96 9.96 0 0 0-5.567 4.99A10.123 10.123 0 0 0 .18 8.08a10.294 10.294 0 0 0 .85 6.5 10.16 10.16 0 0 0 2.667 3.36 9.736 9.736 0 0 0 3.57 1.84 10.19 10.19 0 0 0 5.03.05 8.827 8.827 0 0 0 4.024-2.14 9.185 9.185 0 0 0 2.49-4.17 12.065 12.065 0 0 0 .247-5.34H9.814v3.92h5.36a4.74 4.74 0 0 1-1.964 3.11 5.538 5.538 0 0 1-2.166.88 6.375 6.375 0 0 1-2.345-.01 5.726 5.726 0 0 1-2.188-.97 6.175 6.175 0 0 1-2.25-3.08 6.255 6.255 0 0 1 0-3.92 6.35 6.35 0 0 1 1.426-2.37 5.856 5.856 0 0 1 2.937-1.67 5.755 5.755 0 0 1 2.884.12 5.173 5.173 0 0 1 2.117 1.28c.6-.62 1.2-1.24 1.806-1.85.317-.33.65-.65.956-.99A9.58 9.58 0 0 0 13.225.62 9.713 9.713 0 0 0 6.602.56zm17.773 4.66h2.313v8.19h-2.313V5.22zm-2.813 2.97h8.032v2.31h-8.032V8.19z", "shape-rendering": "geometricPrecision" })
        ),
        _react2["default"].createElement(
          "symbol",
          { id: "icon-twitter" },
          _react2["default"].createElement("path", { d: "M22.094 2.17a7.747 7.747 0 0 1-2.53.73 4.9 4.9 0 0 0 1.9-2.5 7.4 7.4 0 0 1-2.842 1.02 4.517 4.517 0 0 0-3.3-1.43 4.588 4.588 0 0 0-4.557 4.61 4.68 4.68 0 0 0 .117 1.03A13.1 13.1 0 0 1 1.228.85 4.632 4.632 0 0 0 2.61 6.93a2.853 2.853 0 0 1-1.99-.52 4.426 4.426 0 0 0 3.515 4.5 3.51 3.51 0 0 1-1.9.15c.145 1.36 2.022 3.13 4.073 3.13a7.445 7.445 0 0 1-6.31 1.91 13.57 13.57 0 0 0 7.127 2.03A12.734 12.734 0 0 0 19.88 4.68v-.02-.06-.07a7.875 7.875 0 0 0 2.214-2.36z", "shape-rendering": "geometricPrecision" })
        ),
        _react2["default"].createElement(
          "symbol",
          { id: "icon-linkedin" },
          _react2["default"].createElement("path", { d: "M.703 20.74h4.17V6.95H.704v13.79zM16.95 6.48a6.272 6.272 0 0 0-5.12 2.35V6.91H7.644v13.83h4.186v-7.48a3.3 3.3 0 0 1 3.29-3.12c1.83 0 2.278 1.54 2.278 3.08v7.52h4.17v-7.83c0-5.43-2.595-6.43-4.62-6.43zM2.72-.01a2.446 2.446 0 1 0 2.723 2.43A2.592 2.592 0 0 0 2.72-.01zm35.906 19.92", "shape-rendering": "geometricPrecision" })
        ),
        _react2["default"].createElement(
          "symbol",
          { id: "pw-icon" },
          _react2["default"].createElement("path", { d: "M26.618 19.3l1.8-4.87a.55.55 0 0 1 .518-.35h7.486a.55.55 0 0 1 .517.35l1.8 4.87a.543.543 0 0 1-.518.73H27.137a.543.543 0 0 1-.52-.73zm-13.3 0l1.8-4.87a.55.55 0 0 1 .517-.35h7.486a.55.55 0 0 1 .52.35l1.8 4.87a.543.543 0 0 1-.518.73H13.837a.544.544 0 0 1-.52-.73zm6.65-7.03l1.8-4.88a.55.55 0 0 1 .517-.35h7.486a.55.55 0 0 1 .518.35l1.8 4.88a.54.54 0 0 1-.518.72H20.485a.538.538 0 0 1-.517-.72zm-13.3 0l1.8-4.88a.55.55 0 0 1 .518-.35h7.486a.55.55 0 0 1 .517.35l1.8 4.88a.54.54 0 0 1-.52.72H7.187a.538.538 0 0 1-.517-.72zM.018 19.3l1.8-4.87a.55.55 0 0 1 .517-.35H9.82a.55.55 0 0 1 .518.35l1.8 4.87a.544.544 0 0 1-.518.73H.537a.544.544 0 0 1-.518-.73zm13.3-14.07l1.8-4.87a.545.545 0 0 1 .517-.36h7.486a.546.546 0 0 1 .52.36l1.8 4.87a.546.546 0 0 1-.518.73H13.837a.547.547 0 0 1-.52-.73z", "shape-rendering": "geometricPrecision" })
        ),
        _react2["default"].createElement(
          "symbol",
          { id: "icon-pulse" },
          _react2["default"].createElement("path", { d: "M19.272 19.95L14.684 6.11l-2.738 7.34L9.658 10l-1.49 2.25H1.02a1.025 1.025 0 0 1 0-2.05h6.063L9.66 6.32 11.436 9l3.36-9.01 4.56 13.75 1.28-3.54h7.317a1.025 1.025 0 0 1 0 2.05h-5.895z", "shape-rendering": "geometricPrecision" })
        ),
        _react2["default"].createElement(
          "symbol",
          { id: "icon-search" },
          _react2["default"].createElement("path", { d: "M11.233 0a6.74 6.74 0 0 0-6.09 9.673L.297 14.51a1.117 1.117 0 0 0 0 1.582l1.585 1.58a1.12 1.12 0 0 0 1.584 0l4.844-4.836A6.753 6.753 0 1 0 11.234 0zm0 11.256a4.5 4.5 0 1 1 4.51-4.5 4.506 4.506 0 0 1-4.51 4.495z" })
        ),
        _react2["default"].createElement(
          "symbol",
          { id: "icon-close" },
          _react2["default"].createElement("path", { d: "M1.155 29.44L29.44 1.153a4 4 0 0 1 5.656 5.657L6.812 35.097a4 4 0 0 1-5.657-5.657zm0-28.286a4 4 0 0 1 5.657 0L35.096 29.44a4 4 0 0 1-5.657 5.656L1.154 6.81a4 4 0 0 1 0-5.656z" })
        )
      )
    );
  };

  var _AppSvgIcons = AppSvgIcons;
  AppSvgIcons = _wrapComponent("_$AppSvgIcons")(AppSvgIcons) || AppSvgIcons;
  return AppSvgIcons;
})(_react.Component);

exports["default"] = AppSvgIcons;
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./src/components/AppSvgIcons/AppSvgIcons.js
// module id = 666
// module chunks = 0